import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#programs", label: "Programs" },
  { href: "#included", label: "What's Included" },
  { href: "#path", label: "How It Works" },
  { href: "#outcomes", label: "Careers" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#top" className="flex items-center gap-2 cursor-pointer group">
            <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-tools-fill text-xl" aria-hidden="true"></i>
            </div>
            <div className="flex flex-col leading-tight">
              <span
                className={`font-heading font-bold text-lg tracking-tight ${
                  scrolled ? "text-foreground-950" : "text-background-50"
                }`}
              >
                Techy<span className="text-primary-500">Bootcamp</span>
              </span>
              <span
                className={`text-[10px] uppercase tracking-[0.18em] font-mono ${
                  scrolled ? "text-foreground-500" : "text-background-200"
                }`}
              >
                Tech Trade School
              </span>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors cursor-pointer ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100 hover:text-primary-400"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:8888663428"
              className={`inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-500">
                <i className="ri-phone-fill" aria-hidden="true"></i>
              </span>
              888-866-3428
            </a>
            <a
              href="#apply"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
            >
              Enroll Now
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
            aria-label="Toggle menu"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-4 border-t border-background-200 bg-background-50">
            <nav className="flex flex-col py-2">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="px-2 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="tel:8888663428"
                className="mt-2 px-2 py-3 text-sm font-semibold text-foreground-950 flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-phone-fill text-primary-600"></i> 888-866-3428
              </a>
              <a
                href="#apply"
                onClick={() => setOpen(false)}
                className="mt-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold text-center whitespace-nowrap cursor-pointer"
              >
                Enroll Now
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}